import { useState } from 'react';
import { InputValidations, useTranslation } from '@nextgen-web-framework/all';

import { IconName, CurrentPasswordInputProps } from '../../types/propTypes';
import AmwayPasswordField from '../../amway-password-field/AmwayPasswordField';
const CurrentPassword: React.FC<CurrentPasswordInputProps> = (props: CurrentPasswordInputProps) => {
  const { label, name, onInputChangeCallback, error, setError, required = true, forceError, placeholder } = props;
  const t = useTranslation();

  const [state, setState] = useState({
    touched: false,
    password: '',
    inputType: 'password',
    icon: { iconName: 'eye-slash' } as IconName,
  });

  const errorAndTouched = error && state.touched;
  const status = errorAndTouched || forceError ? InputValidations.INVALID : InputValidations.DEFAULT;
  const message = status === InputValidations.INVALID ? error : '';
  const requirePassword = t('identity.ErrorMessages.requirePassword');

  const changeVisibilityHandler = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setState((prevState) => ({
      ...prevState,
      inputType: prevState.inputType === 'password' ? 'text' : 'password',
      icon: {
        iconName: prevState.icon.iconName === 'eye-slash' ? 'eye' : 'eye-slash',
      },
    }));
  };
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const newValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      touched: true,
      password: newValue,
    }));
    newValue ? setError?.('') : setError?.(requirePassword);

    onInputChangeCallback?.(e);
  };
  return (
    <AmwayPasswordField
      data-testid="password_field"
      name={name}
      required={required}
      placeholder={placeholder}
      values={state.password}
      type={state.inputType}
      inputIcon={state.icon}
      label={label}
      inputIconOnClick={changeVisibilityHandler}
      onChange={onChange}
      message={message}
      status={status}
    />
  );
};

export default CurrentPassword;
